import { render, staticRenderFns } from "./SwapGroupsDropdown.vue?vue&type=template&id=5dc643e8"
import script from "./SwapGroupsDropdown.js?vue&type=script&lang=js&external"
export * from "./SwapGroupsDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports